module.exports = __webpack_public_path__ + "static/TUTEURALHEURE_LOGORS_TUTEUR_LOGOCHAPEAU_BLEU_POURFONDCLAIR-fee2309f0ff0ac3f35997b97a40977d0.png";